<template>
  <div class="check-visit-time-wrapper">
    <p class="check-title">
      <i class="richic-warn"></i>
      {{$t('FoodOpB_1_There_may_scoc' /** 计划时间可能存在冲突，该日计划如下: */)}}
    </p>
    <ul>
      <li
        class="shop-visit-plan"
        v-for="(item, index) in list"
        :key="'key' + index"
        v-text="item"
      ></li>
    </ul>
  </div>
</template>
<script>
import { isArray } from 'lodash-es'

export default {
  name: 'CheckVisitTime',
  props: {
    value: {
      required: false
    }
  },
  data () {
    return {
      list: []
    }
  },
  watch: {
    value (nVal) {
      this.valueChange(nVal)
    }
  },
  created () {
    this.valueChange(this.value)
  },
  methods: {
    valueChange (val) {
      this.list.length = 0
      if (isArray(val)) {
        this.list.push(...val)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.check-visit-time-wrapper
  .check-title
    font-size: 28px
    color: #333
    .richic-warn
      color: #ff5253
  .shop-visit-plan
    margin-top: 6PX
    font-size: 28px
</style>
